import { useEffect, useState } from 'react'

export function useDevice(threshold: number = 620) {
  const [isMobile, setIsMobile] = useState(computeIsMobile(threshold))

  useEffect(() => {
    window.addEventListener('resize', computeWindowWidth)
    return () => window.removeEventListener('resize', computeWindowWidth)
  }, [])

  const computeWindowWidth = () => {
    const isMobile = computeIsMobile(threshold)
    setIsMobile(isMobile)
  }

  return [isMobile]
}

function computeIsMobile(threshold: number) {
  return window.innerWidth <= threshold
}
